import * as React from 'react';
import classnames from 'classnames';

import './tile-standard-content-details-section.scss';

type Props = {
  label: string,
  children: React.ReactNode,
  size?: 'small' | 'normal',
  labelLineHeight?: 'small'
};

const TileStandardContentDetailsSection = (
  {
    label,
    children,
    size = 'normal',
    labelLineHeight
  }: Props
): JSX.Element => {
  const containerClasses = classnames('tile-standard-content-details-section', {
    [`tile-standard-content-details-section--size-${size}`]: Boolean(size)
  });

  const labelClasses = classnames('tile-standard-content-details-section__label', {
    [`tile-standard-content-details-section__label--line-height-${labelLineHeight}`]: Boolean(labelLineHeight)
  });

  return (
    <div className={containerClasses}>
      <div
        className={labelClasses}
        title={label}
      >
        {label}
      </div>
      {children}
    </div>
  );
};

export default TileStandardContentDetailsSection;
